export const genderOptions = [
    {
        id : 1 ,
        key : 'Male' ,
        value : 'male'
    } ,
    {
        id : 2 ,
        key : 'Female' ,
        value : 'female'
    } ,
    {
        id : 3 ,
        key : 'Other' ,
        value : 'other'
    } ,
]

export const castRoles = [
    {
        id: 1,
        key: 'Author',
        value: 'author',
    },
    {
        id: 2,
        key: 'Dramaturg',
        value: 'dramaTurg',
    },
    {
        id: 3,
        key: 'Translators',
        value: 'translators',
    },
    {
        id: 4,
        key: 'Production Company',
        value: 'productionCompany',
    },
    {
        id: 5,
        key: 'Director',
        value: 'director',
    },
    {
        id: 6,
        key: 'Music Director',
        value: 'musicDirector',
    },
    {
        id: 7,
        key: 'Lead Cast',
        value: 'leadCast',
    },
    {
        id: 8,
        key: 'Secondary Cast',
        value: 'secondaryCast',
    },
    {
        id: 9,
        key: 'Production Staff',
        value: 'productionStaff',
    },
];



// Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia porro sit, voluptate est quidem maiores nisi eveniet vero asperiores officia!